import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EchantillonnagePhyto } from 'src/app/domain/Lac - EAU/echantillonnage-phyto';

@Component({
    selector: 'app-lac-phyto-echant-dialog',
    templateUrl: './lac-phyto-echant-dialog.component.html',
    styleUrls: ['./lac-phyto-echant-dialog.component.scss']
})
export class LacPhytoEchantComponent implements OnInit {
    public PMAX = 150; // m
    public VMAX = 400; // m
    ValidVolumeMax = new UntypedFormControl(0, [Validators.max(this.VMAX), Validators.min(0)]);
    ValidProfMax = new UntypedFormControl(0, [Validators.max(this.PMAX), Validators.min(0)]);
    public NewPrelevement: EchantillonnagePhyto;

    constructor(
        private dialogRef: MatDialogRef<LacPhytoEchantComponent>,
        @Inject(MAT_DIALOG_DATA) public data) {

        this.NewPrelevement = data ?? new EchantillonnagePhyto();
    }

    ngOnInit(): void {
        this.ValidProfMax.markAsTouched();
        this.ValidVolumeMax.markAsTouched();
    }

    CanAddNewMeasure() {
        return this.NewPrelevement.Profondeur && this.NewPrelevement.Volume &&
            this.ValidVolumeMax.valid && this.ValidProfMax.valid;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        this.dialogRef.close(this.NewPrelevement);
    }
}
